// extracted by mini-css-extract-plugin
export default {"container":"modal_confirmation_content-module__container--682HY"};